const formValidation = require("base/components/formValidation");
const formHelpers = require("coremh/components/formErrors");
const encryption = require("migration/components/encryption");
const { accountKeyboardAccessibility } = require("coremh/components/accessibilityFunctions");

module.exports = {
    login: function () {
        const formLogin = $("form.login");
        var form = null;

        setTimeout(function () {
            if ($("#login-form-email:-webkit-autofill").length > 0 && $("#login-form-password:-webkit-autofill").length > 0) {
                var btnSubmitLogin = formLogin.find("button[type='submit']");
                btnSubmitLogin.removeClass("disabled");
                btnSubmitLogin.attr("disabled", false);
            }
        }, 300);

        /**
         * @description ajax error callback for login
         * @param {Object} data The data returned by the server
         * @returns {void}
         */
        function handleLoginError(data) {
            if (data.responseJSON.redirectUrl) {
                window.location.href = data.responseJSON.redirectUrl;
            } else {
                formLogin.trigger("login:error", data);
                form.spinner().stop();
            }
        }

        /**
         * @description ajax success callback for login
         * @param {Object} data The data returned by the server
         * @returns {void}
         */
        function handleLoginSuccess(data) {
            form.spinner().stop();
            if (!data.success) {
                formHelpers.loadFormErrors(form, data);
                $.spinner().stop();
            } else {
                if (form.find(".login-link").length) {
                    window.location.reload();
                } else {
                    location.href = data.redirectUrl;
                }
            }
        }

        formLogin.submit(function (e) {
            form = $(this);
            e.preventDefault();
            var url = form.attr("action");
            form.spinner().start();
            formLogin.trigger("login:submit", e);
            var formData = form.serialize();

            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                data: formData,
                success: function (data) {
                    if (data.iterations && data.salt) {
                        // user is legacy, we need to generate the hash and resubmit
                        var input = form.find("input[name$=_password]");
                        var iterations = Number(data.iterations);
                        var hash = encryption(input.val(), iterations, data.salt);
                        var migrationData = formData + "&hash=" + hash;

                        $.ajax({
                            url: url,
                            type: "post",
                            dataType: "json",
                            data: migrationData,
                            success: handleLoginSuccess,
                            error: handleLoginError
                        });
                    } else {
                        handleLoginSuccess(data);
                    }
                },
                error: handleLoginError
            });

            return false;
        });
    },

    resetPassword: function () {
        $(".reset-password-form").submit(function (e) {
            var form = $(this);
            var resetPasswordModal = $("#requestPasswordResetModal");
            e.preventDefault();
            var url = form.attr("action");
            resetPasswordModal.spinner().start();
            $(".reset-password-form").trigger("login:register", e);
            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                data: form.serialize(),
                success: function (data) {
                    resetPasswordModal.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $(".request-password-title").text(data.receivedMsgHeading).addClass("passConfirmation");
                        $(".request-password-body").empty()
                            .append("<p>" + data.receivedMsgBody + "</p>");
                        $(".send-email-btn").empty()
                            .html("<a href='"
                                + data.returnUrl
                                + "' class='btn btn-primary btn-wide text-center'>"
                                + data.buttonText + "</a>"
                            );
                    }
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });
    },

    clearResetForm: function () {
        $("#login .modal").on("hidden.bs.modal", function () {
            $("#reset-password-email").val("");
            $(".modal-dialog .form-control.is-invalid").removeClass("is-invalid");
        });
    },

    userLogout: function () {
        $(".logout-link").on("click", function (e) {
            e.preventDefault();
            const $confirmationPage = $("#order-confirmation-page");
            $.spinner().start();
            $.ajax({
                url: $(this).attr("href"),
                method: "GET",
                success: function (response) {
                    if (response.success) {
                        if ($confirmationPage.length) {
                            location.href = response.redirectUrl;
                        } else {
                            window.location.reload();
                        }
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    forgetPassword: function () {
        $(".account-popin .password-reset").on("click", function () {
            $(".account-popin").removeClass("show");
        });
    },

    accountKeyboardAccessibility: accountKeyboardAccessibility()
};
